import { Filters } from "@saleor/types";
import { stringifyQs } from "@saleor/utils/urls";

export enum KamsUrlFiltersEnum {
  brand = "brand"
}

export type KamsUrlFilters = Filters<KamsUrlFiltersEnum>;

export type KamsUrlQueryParams = KamsUrlFilters;

export const kamsUrl = (params?: KamsUrlQueryParams) =>
  "?" + stringifyQs(params);
